export const T = {
  en_GB: {
    statusPending: "Queued",
    statusProcessing: "Transcribing…",
    statusFailed: "Transcription failed",
  },
  nb_NO: {
    statusPending: "I kø",
    statusProcessing: "Transkriberer…",
    statusFailed: "Transkripsjon feilet",
  },
} as const;
